var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Cancel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00016 1.33301C4.3135 1.33301 1.3335 4.31301 1.3335 7.99967C1.3335 11.6863 4.3135 14.6663 8.00016 14.6663C11.6868 14.6663 14.6668 11.6863 14.6668 7.99967C14.6668 4.31301 11.6868 1.33301 8.00016 1.33301ZM10.8668 10.8663C10.6068 11.1263 10.1868 11.1263 9.92683 10.8663L8.00016 8.93967L6.0735 10.8663C5.8135 11.1263 5.3935 11.1263 5.1335 10.8663C4.8735 10.6063 4.8735 10.1863 5.1335 9.92634L7.06016 7.99967L5.1335 6.07301C4.8735 5.81301 4.8735 5.39301 5.1335 5.13301C5.3935 4.87301 5.8135 4.87301 6.0735 5.13301L8.00016 7.05967L9.92683 5.13301C10.1868 4.87301 10.6068 4.87301 10.8668 5.13301C11.1268 5.39301 11.1268 5.81301 10.8668 6.07301L8.94016 7.99967L10.8668 9.92634C11.1202 10.1797 11.1202 10.6063 10.8668 10.8663Z",
    fill: "#7E8286"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon-cancel.e75f734d78ed0a56e23f4c7ed61cba11.svg";
export { ForwardRef as ReactComponent };